// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1dbFl","signatureButtonsRight":"ModalSign_signatureButtonsRight__3GyMD"};